package org.example.project.model

import kotlinx.serialization.Serializable

@Serializable
enum class TimerMode {
    TURN,
    QUESTION,
    NONE
}